/** Sample contact used when resolving merge tags in the content Preview modal. */
export const CAMPAIGN_PREVIEW_SAMPLE_CONTACT: Record<string, string> = {
  first_name: 'Alex',
  last_name: 'Sample',
  firstName: 'Alex',
  lastName: 'Sample',
  email: 'alex.sample@example.com',
  unsubscribeUrl: '#unsubscribe-sample',
  preferencesUrl: '#preferences-sample',
  orgName: 'SELISE Cloud',
};

const KNOWN_MERGE_TOKENS = new Set(Object.keys(CAMPAIGN_PREVIEW_SAMPLE_CONTACT));

export const substituteCampaignMergeTags = (
  html: string,
  sample: Record<string, string> = CAMPAIGN_PREVIEW_SAMPLE_CONTACT
): string =>
  String(html || '').replace(/\{\{\s*([A-Za-z0-9_.]+)\s*\}\}/g, (match, token: string) =>
    sample[token] != null ? String(sample[token]) : match
  );

export const extractUnresolvedCampaignMergeTags = (html: string): string[] => {
  const found = new Set<string>();
  String(html || '').replace(/\{\{\s*([A-Za-z0-9_.]+)\s*\}\}/g, (_match, token: string) => {
    if (!KNOWN_MERGE_TOKENS.has(token)) {
      found.add(token);
    }
    return '';
  });
  return [...found];
};

export const formatCampaignContentSavedLabel = (
  savedAt?: string | null,
  version?: number | null
): string => {
  if (!savedAt?.trim()) {
    return 'No content saved yet.';
  }
  const date = new Date(savedAt);
  if (Number.isNaN(date.getTime())) {
    return 'No content saved yet.';
  }
  // Match prototype campaign-editor.html fmtDateTime: "Sep 06, 2026 · 4:41 PM"
  const day = date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
  if (version && version > 0) return `Version ${version} · saved ${day} · ${time}`;
  return `Saved ${day} · ${time}`;
};
